import TopSVG from '../../../assests/svg/lio-intelligence-loader-top.svg';
import MiddleSVG from '../../../assests/svg/lio-intelligence-loader-mid.svg';
import BottomSVG from '../../../assests/svg/lio-intelligence-loader-bottom.svg';
import {Box} from '@mui/material';

const AurIntelligenceLoader = () => {
  return (
    <div className="aur-intelligence-loader-svg-container">
      <Box>
        <Box sx={{position: 'absolute'}}>
          <img src={BottomSVG} alt="Bottom" className="bottom-svg" />
        </Box>
        <Box sx={{position: 'absolute'}}>
          <img src={MiddleSVG} alt="Middle" className="middle-svg" />
        </Box>
        <Box sx={{position: 'absolute'}}>
          <img src={TopSVG} alt="Top" className="top-svg" />
        </Box>
      </Box>
    </div>
  );
};

export default AurIntelligenceLoader;
